import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";
import { PrimaryCTA } from "@/components/revanche/PrimaryCTA";
import { previewStart, previewStatus } from "@/lib/photo";

const Teasing = () => {
    const navigate = useNavigate();
    const [target, setTarget] = useState(null);
    const [count, setCount] = useState(0);

    // Nombre d'axes : tiré au hasard (6-9) et enregistré côté serveur, SANS aucun appel IA.
    // On réutilise exactement ce nombre dans le vrai rapport après paiement.
    useEffect(() => {
        let active = true;
        const pv = (() => { try { return JSON.parse(localStorage.getItem("revanche_preview") || "null"); } catch (e) { return null; } })();
        if (pv && pv.n_axes) { setTarget(pv.n_axes); return undefined; }
        previewStart()
            .then(() => previewStatus())
            .then((s) => {
                if (!active) return;
                if (s && s.preview) {
                    localStorage.setItem("revanche_preview", JSON.stringify(s.preview));
                    setTarget(s.preview.n_axes || 7);
                } else setTarget(7);
            })
            .catch(() => { if (active) setTarget(7); });
        return () => { active = false; };
    }, []);

    useEffect(() => {
        if (target == null) return undefined;
        const dur = 800;
        const start = Date.now();
        const id = setInterval(() => {
            const t = Math.min(1, (Date.now() - start) / dur);
            setCount(Math.round(t * target));
            if (t >= 1) clearInterval(id);
        }, 40);
        return () => clearInterval(id);
    }, [target]);

    return (
        <div className="fixed inset-0 bg-black max-w-[480px] mx-auto flex flex-col" data-testid="teasing-screen">
            <div className="flex-1 min-h-0 flex flex-col items-center justify-center text-center" style={{ paddingLeft: 24, paddingRight: 24 }}>
                <motion.div
                    initial={{ scale: 0.6, opacity: 0 }}
                    animate={{ scale: [0.6, 1.25, 1], opacity: 1 }}
                    transition={{ duration: 0.5, ease: "easeOut", times: [0, 0.6, 1] }}
                    data-testid="teasing-alert-icon"
                >
                    <AlertTriangle size={32} strokeWidth={2.5} style={{ color: "var(--red)" }} />
                </motion.div>
                <p className="font-body" style={{ marginTop: 20, fontSize: "16px", color: "var(--text-secondary)" }}>
                    On a détecté
                </p>
                <span
                    data-testid="teasing-count"
                    className="font-display"
                    style={{ fontSize: "96px", fontWeight: 800, lineHeight: 1, color: "#FFFFFF", marginTop: 4 }}
                >
                    {count}
                </span>
                <p className="font-body" style={{ marginTop: 8, fontSize: "20px", color: "#FFFFFF", maxWidth: 320, lineHeight: 1.25 }}>
                    raisons pour lesquelles tu n'es pas à ton maximum.
                </p>
            </div>
            <div className="shrink-0 safe-bottom" style={{ paddingLeft: 24, paddingRight: 24, paddingBottom: 24 }}>
                <PrimaryCTA dataTestId="btn-see-analysis" onClick={() => navigate("/analyse-en-cours")}>
                    Voir mon analyse complète
                </PrimaryCTA>
            </div>
        </div>
    );
};

export default Teasing;
